import Inline from '../blots/inline.js';
let Underline = /*#__PURE__*/(() => {
  class Underline extends Inline {
    static blotName = 'underline';
    static tagName = 'U';
  }
  return Underline;
})();
export default Underline;
